import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DisconnectPayPalMutation } from "../graphql/mutations";
import type {
  DisconnectPayPalMutationType,
  DisconnectPayPalMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDisconnectPayPalMutation = (
  options?: MutationHookOptions<
    DisconnectPayPalMutationType,
    DisconnectPayPalMutationVariablesType
  >
) => {
  return useMutation<
    DisconnectPayPalMutationType,
    DisconnectPayPalMutationVariablesType
  >(DisconnectPayPalMutation, options);
};
